function Presentation() {
    return (
      <div id="presentation" className="my-5">
          <h1 className="text-3xl font-bold sm:text-4xl md:text-6xl mb-6">
              Hi, I'm <span className="text-zinc-400">Sammy</span> 
          </h1>
          <p className="opacity-90 text-lg">
            My name is Sammy, and I'm 24 years old. I currently work for a digital
            health care company in Paris, where I've been since February 2020. 
          </p>
      </div>
    );
  }
  
  export default Presentation;
  